// extracted by mini-css-extract-plugin
export default {"root":"IconHourGlassLine_root__kZ5oR"};